// extracted by mini-css-extract-plugin
export default {"headline":"FundDetails_headline__FKt05","title":"FundDetails_title__jhiFn","textExpander":"FundDetails_textExpander__aaXUV"};